import { render, staticRenderFns } from "./HoldDispositionForm.vue?vue&type=template&id=235d308a&scoped=true&"
import script from "./HoldDispositionForm.vue?vue&type=script&lang=ts&"
export * from "./HoldDispositionForm.vue?vue&type=script&lang=ts&"
import style0 from "./HoldDispositionForm.vue?vue&type=style&index=0&id=235d308a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235d308a",
  null
  
)

export default component.exports